import { useKeycloak } from "@react-keycloak/web";
import { Avatar, Dropdown } from "antd";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import PLACEHOLDER_IMG from "../../../assets/images/avatar.svg";
import { useGetEmployeeDetailsQuery } from "../../../features/employee/employeeApi";

export default function ProfileMenu() {
  // const dispatch = useAppDispatch();
  const { keycloak } = useKeycloak();
  const { authInfo } = useAppSelector((state) => state.auth);
  const { data } = useGetEmployeeDetailsQuery(authInfo?.id?.toString() || "", {
    skip: !authInfo?.id,
  });

  const navigateUrl =
    authInfo?.role === "Admin" ? "/admin/profile" : "/admin/user-dashboard";

  return (
    <Dropdown
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      className="cursor-pointer"
      rootClassName="!left-auto !right-5"
      dropdownRender={() => (
        <ul className="list-none bg-white shadow p-1 rounded">
          <li>
            <Link
              to={navigateUrl}
              className="py-1.5 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded block"
            >
              My Profile
            </Link>
          </li>
          <li
            onClick={() => {
              // dispatch(userLoggedOut());
              keycloak.logout();
              localStorage.clear();
            }}
            className="py-1.5 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded"
          >
            Logout
          </li>
        </ul>
      )}
    >
      <div className="flex items-center gap-2.5 cursor-pointer">
        <Avatar
          size={44}
          src={
            data?.data?.employee?.member?.profile?.pro_pic || PLACEHOLDER_IMG
          }
        />
        {/* <span className="text-[#555b6d] text-base font-medium flex items-center">
          {login?.firstName} <BottomDropdownIcon />
        </span> */}
      </div>
    </Dropdown>
  );
}
